// extracted by mini-css-extract-plugin
export var licenseSuggestActive = "license-suggest_active_Ar4dB0Detur4n17u_wmg";